import KaorioHistoryLayout from './KaorioHistoryLayout';

export default KaorioHistoryLayout;
